import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AboutScreen = () => {
  const teamMembers = [
    {
      name: 'Veronika Prawasti',
      role: 'Founder',
      image: '/images/team/veronika.png',
      description: 'With 19 years of experience in Indonesian hospitality and tourism, Veronika is an accomplished client-focused global wedding and event coordinator. As the founder of BALIVIP Wedding, her greatest strength lies in capturing the magic in every wedding. She is also the chairwoman of the Bali Wedding Association.'
    },
    {
      name: 'Casavia',
      role: 'Wedding Manager',
      image: '/images/team/casavia.png',
      description: 'From initial planning to execution on the big day, Casavia manages intricate details and logistics to create seamless weddings. Her attention to detail, creativity, problem-solving, and excellent communication skills ensure a stress-free experience for every couple.'
    },
    {
      name: 'Jennifer',
      role: 'Wedding Planner',
      image: '/images/team/jennifer.png',
      description: 'Jennifer provides support and assistance in organizing and executing weddings. She helps with research, vendor coordination, administrative duties, and on-site event management throughout the planning process.'
    }
  ];

  return (
    <div style={{ 
      background: 'linear-gradient(180deg, #0d1117 0%, #1a1a2e 50%, #0d1117 100%)', 
      minHeight: '100vh',
      paddingTop: '100px',
      paddingBottom: '80px'
    }}>
      <Container>
        {/* Back Link */}
        <Link 
          to="/" 
          style={{ 
            color: 'rgba(255,255,255,0.5)', 
            textDecoration: 'none',
            fontSize: '0.9rem',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '2rem'
          }}
        >
          ← Back to Home
        </Link>

        {/* Header */}
        <div className="text-center mb-5">
          <h1 style={{ 
            color: '#fff', 
            fontFamily: "'Playfair Display', serif",
            fontSize: '3rem',
            marginBottom: '1rem'
          }}>
            About <span style={{ color: '#d4af37' }}>BALIVIP</span> Wedding
          </h1>
          <p style={{ 
            color: 'rgba(255,255,255,0.7)', 
            maxWidth: '700px', 
            margin: '0 auto',
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}>
            Creating timeless moments of elegance and romance since 2003. We provide a one-stop service 
            for all your wedding needs, ensuring an enjoyable and stress-free planning experience 
            for your dream destination wedding in Bali.
          </p>
        </div>

        {/* Featured In */}
        <div className="text-center mb-5">
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginBottom: '1rem' }}>
            FEATURED IN
          </p>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '2rem', 
            flexWrap: 'wrap',
            color: 'rgba(255,255,255,0.5)',
            fontSize: '0.9rem'
          }}>
            <span>Honeycombers</span>
            <span>•</span>
            <span>The Bali Bride</span>
            <span>•</span>
            <span>Style Me Pretty</span>
            <span>•</span>
            <span>Bridestory</span>
          </div>
        </div>

        {/* Team Section */}
        <div className="mb-5">
          <h2 className="text-center" style={{ 
            color: '#fff', 
            fontFamily: "'Playfair Display', serif",
            marginBottom: '3rem'
          }}>
            Meet The Team
          </h2>
          
          <Row className="justify-content-center g-4">
            {teamMembers.map((member, index) => (
              <Col key={index} md={4}>
                <Card style={{ 
                  background: 'rgba(255,255,255,0.03)', 
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  height: '100%',
                  transition: 'all 0.3s ease'
                }}
                className="team-card"
                >
                  <div style={{
                    height: '280px',
                    background: 'linear-gradient(135deg, rgba(212,175,55,0.1), rgba(139,92,246,0.1))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                  }}>
                    <img 
                      src={member.image} 
                      alt={member.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'top center'
                      }}
                    />
                  </div>
                  <Card.Body style={{ padding: '1.5rem' }}>
                    <div style={{ 
                      color: '#d4af37', 
                      fontSize: '0.75rem', 
                      textTransform: 'uppercase',
                      letterSpacing: '2px',
                      marginBottom: '0.5rem'
                    }}>
                      {member.role}
                    </div>
                    <h4 style={{ 
                      color: '#fff', 
                      fontFamily: "'Playfair Display', serif",
                      marginBottom: '1rem'
                    }}>
                      {member.name}
                    </h4>
                    <p style={{ 
                      color: 'rgba(255,255,255,0.6)', 
                      fontSize: '0.9rem',
                      lineHeight: '1.6'
                    }}>
                      {member.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Bali Wedding Association */}
        <div className="text-center" style={{
          background: 'rgba(212,175,55,0.05)',
          border: '1px solid rgba(212,175,55,0.2)',
          borderRadius: '20px',
          padding: '3rem',
          marginTop: '3rem'
        }}>
          <h3 style={{ 
            color: '#fff', 
            fontFamily: "'Playfair Display', serif",
            marginBottom: '1rem'
          }}>
            Bali Wedding Association
          </h3>
          <p style={{ 
            color: 'rgba(255,255,255,0.6)', 
            maxWidth: '600px', 
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            With Veronika as the chairwoman, the Bali Wedding Association serves as a professional 
            organization for the wedding business in Indonesia. Launched in April 2014, its vision 
            is to make Bali one of the most sought-after wedding destinations worldwide.
          </p>
          <a 
            href="https://baliweddingassociation.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              marginTop: '1.5rem',
              color: '#d4af37',
              textDecoration: 'none',
              fontSize: '0.9rem'
            }}
          >
            Visit Bali Wedding Association →
          </a>
        </div>

        {/* Contact Info */}
        <div className="text-center mt-5">
          <h4 style={{ color: '#fff', marginBottom: '1rem' }}>Head Office</h4>
          <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '0.5rem' }}>
            Jalan By Pass Ngurah Rai No.349 Sanur, Denpasar Selatan, Bali 80288
          </p>
          <p style={{ color: 'rgba(255,255,255,0.6)' }}>
            <a href="mailto:hello@balivipwedding.com" style={{ color: '#d4af37' }}>hello@balivipwedding.com</a>
            {' '} | {' '}
            <a href="tel:+6281337202227" style={{ color: '#d4af37' }}>+6281337202227</a>
          </p>
        </div>
      </Container>

      <style>{`
        .team-card:hover {
          border-color: rgba(212,175,55,0.4) !important;
          transform: translateY(-5px);
        }
      `}</style>
    </div>
  );
};

export default AboutScreen;
